(function() {
    const box = document.getElementById('main-content');
    if (!window.__dx1__video__) {
        window.__dx1__video__ = {};
    }

    const _dx1 = window.__dx1__video__;

    _dx1.screenHeight = window.innerHeight;
    _dx1.screenWidth = window.innerWidth;
    let nodeList = $narwal.getNodeList(box);
    $narwal.on('resize', () => {
        _dx1.initOffset();
    });
    // 初始化偏移量
    _dx1.initOffset = function() {
        const videoList = [];
        const list = [].concat($narwal.isMobile ? nodeList.videoH5 : nodeList.videoPc);
        list.forEach(node => {
            videoList.push({
                node,
                play: false,
                top: $narwal.getOffset(node).top
            });
        });

        _dx1.videoList = videoList;
        _dx1.screenHeight = window.innerHeight;
        _dx1.screenWidth = window.innerWidth;
    };

    _dx1.initOffset();
    // 播放视频
    if (!_dx1.playVideo) {
        _dx1.playVideo = function(scrollTop) {
            const list = _dx1.videoList;
            if (list && list.length > 0) {
                list.forEach(obj => {
                    if (!obj.play
                        && scrollTop + _dx1.screenHeight > obj.top
                        && scrollTop - _dx1.screenHeight < obj.top
                    ) {
                        obj.node.play();
                        obj.play = true;
                    } else if (obj.play && (scrollTop > obj.top + _dx1.screenHeight || scrollTop + _dx1.screenHeight < obj.top)) {
                        obj.node.pause();
                        obj.play = false;
                    }
                });
            }
        };

        document.addEventListener('scroll', function() {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            _dx1.playVideo(scrollTop);
        }, { passive: true });
    }
})();